
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("4m9ze", function(module, exports) {
$parcel$export(module.exports, "autoScrollForElements", () => $d22dc53b7c6d47d8$export$4b66ee8317094cdb);
$parcel$export(module.exports, "autoScrollWindowForElements", () => $d22dc53b7c6d47d8$export$c9168f41de61f525);

var $ejG4k = parcelRequire("ejG4k");

var $gU4k2 = parcelRequire("gU4k2");
const $d22dc53b7c6d47d8$var$api = (0, $gU4k2.makeApi)({
    monitor: (0, $ejG4k.monitorForElements)
});
const $d22dc53b7c6d47d8$export$4b66ee8317094cdb = $d22dc53b7c6d47d8$var$api.autoScroll;
const $d22dc53b7c6d47d8$export$c9168f41de61f525 = $d22dc53b7c6d47d8$var$api.autoScrollWindow;

});
parcelRegister("gU4k2", function(module, exports) {
$parcel$export(module.exports, "makeApi", () => $5362001483add6e7$export$b8fa21320a811083);

var $cdLl4 = parcelRequire("cdLl4");

var $1q0tL = parcelRequire("1q0tL");

var $ixgV0 = parcelRequire("ixgV0");

var $bnfrg = parcelRequire("bnfrg");

var $7OtQA = parcelRequire("7OtQA");
function $5362001483add6e7$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $cdLl4.combine)((0, $bnfrg.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $1q0tL.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $1q0tL.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $7OtQA.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $ixgV0.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("ixgV0", function(module, exports) {
$parcel$export(module.exports, "getScheduler", () => $df05416f4583f8f1$export$5cff7ac265db316a);

var $04W7N = parcelRequire("04W7N");

var $UwvOF = parcelRequire("UwvOF");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $df05416f4583f8f1$var$schedulers = new Map();
function $df05416f4583f8f1$export$5cff7ac265db316a(monitor) {
    const scheduler = $df05416f4583f8f1$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $df05416f4583f8f1$var$makeScheduler(monitor);
    $df05416f4583f8f1$var$schedulers.set(monitor, created);
    return created;
}
function $df05416f4583f8f1$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $04W7N.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $UwvOF.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $UwvOF.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("UwvOF", function(module, exports) {
$parcel$export(module.exports, "markAndGetEngagement", () => $7beaa2760ecf84b7$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $7beaa2760ecf84b7$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $7beaa2760ecf84b7$export$13ae770ed39b71ea);
const $7beaa2760ecf84b7$var$ledger = new Map();
const $7beaa2760ecf84b7$var$requested = new Set();
function $7beaa2760ecf84b7$export$8c764c3f2fc3d2d2(element) {
    $7beaa2760ecf84b7$export$1cb7cbb266b6f6fa(element);
    const entry = $7beaa2760ecf84b7$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $7beaa2760ecf84b7$var$ledger.set(element, fresh);
    return fresh;
}
function $7beaa2760ecf84b7$export$1cb7cbb266b6f6fa(element) {
    $7beaa2760ecf84b7$var$requested.add(element);
}
function $7beaa2760ecf84b7$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $7beaa2760ecf84b7$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $7beaa2760ecf84b7$var$ledger.forEach((_, element)=>{
        if (!$7beaa2760ecf84b7$var$requested.has(element)) $7beaa2760ecf84b7$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $7beaa2760ecf84b7$var$requested.clear();
}
function $7beaa2760ecf84b7$export$13ae770ed39b71ea() {
    $7beaa2760ecf84b7$var$ledger.clear();
}

});


parcelRegister("bnfrg", function(module, exports) {
$parcel$export(module.exports, "selector", () => $84ba6b6403901ac6$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $84ba6b6403901ac6$export$4ec12fb57dfebd53);
const $84ba6b6403901ac6$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $84ba6b6403901ac6$export$aea217a45095ce11 = `[${$84ba6b6403901ac6$export$4b152ab55cad4fd6}="true"]`;
function $84ba6b6403901ac6$export$4ec12fb57dfebd53(element) {
    element.setAttribute($84ba6b6403901ac6$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($84ba6b6403901ac6$export$4b152ab55cad4fd6);
}

});

parcelRegister("7OtQA", function(module, exports) {
$parcel$export(module.exports, "tryScroll", () => $a47bca182f55e08f$export$233199807749476d);

var $1UMUB = parcelRequire("1UMUB");

var $UwvOF = parcelRequire("UwvOF");

var $bnfrg = parcelRequire("bnfrg");

var $eOZR6 = parcelRequire("eOZR6");
function $a47bca182f55e08f$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $a47bca182f55e08f$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    var _container$getConfigu, _container$getAllowed;
    // we cannot do any more scrolling
    if (!$a47bca182f55e08f$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $bnfrg.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $a47bca182f55e08f$var$tryScrollElements({
            target: (element === null || element === void 0 ? void 0 : element.parentElement) ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $UwvOF.markAndGetEngagement)(element);
    const config = (0, $1UMUB.getInternalConfig)((_container$getConfigu = container.getConfiguration) === null || _container$getConfigu === void 0 ? void 0 : _container$getConfigu.call(container, feedback));
    const allowedAxis = ((_container$getAllowed = container.getAllowedAxis) === null || _container$getAllowed === void 0 ? void 0 : _container$getAllowed.call(container, feedback)) ?? 'all';
    const scrollBy = (0, $eOZR6.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $a47bca182f55e08f$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        var _entry$getConfigurati, _entry$getAllowedAxis;
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $UwvOF.markAndGetEngagement)(element);
        const config = (0, $1UMUB.getInternalConfig)((_entry$getConfigurati = entry.getConfiguration) === null || _entry$getConfigurati === void 0 ? void 0 : _entry$getConfigurati.call(entry, feedback));
        const allowedAxis = ((_entry$getAllowedAxis = entry.getAllowedAxis) === null || _entry$getAllowedAxis === void 0 ? void 0 : _entry$getAllowedAxis.call(entry, feedback)) ?? 'all';
        const scrollBy = (0, $eOZR6.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $a47bca182f55e08f$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $a47bca182f55e08f$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$a47bca182f55e08f$var$isScrollingAvailable(remainder)) return;
    $a47bca182f55e08f$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("1UMUB", function(module, exports) {
$parcel$export(module.exports, "getInternalConfig", () => $b0c2973d37eab94d$export$e96028ec7ff9d079);
const $b0c2973d37eab94d$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $b0c2973d37eab94d$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $b0c2973d37eab94d$export$e96028ec7ff9d079(provided) {
    return {
        ...$b0c2973d37eab94d$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $b0c2973d37eab94d$var$maxPixelScrollPerSecond[(provided === null || provided === void 0 ? void 0 : provided.maxScrollSpeed) ?? 'standard']
    };
}

});

parcelRegister("eOZR6", function(module, exports) {
$parcel$export(module.exports, "getScrollBy", () => $524d1235758f9595$export$6cfa6dfe6898b98f);

var $1jOn2 = parcelRequire("1jOn2");

var $c7fDC = parcelRequire("c7fDC");

var $bRr7K = parcelRequire("bRr7K");

var $d8KWd = parcelRequire("d8KWd");

var $hCt4e = parcelRequire("hCt4e");

var $7ZBkw = parcelRequire("7ZBkw");
function $524d1235758f9595$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $524d1235758f9595$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $524d1235758f9595$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $c7fDC.edges).reduce((map, edge)=>{
        const hitbox = (0, $bRr7K.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $c7fDC.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $hCt4e.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $7ZBkw.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $1jOn2.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $d8KWd.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $d8KWd.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $d8KWd.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $d8KWd.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("1jOn2", function(module, exports) {
$parcel$export(module.exports, "canScrollOnEdge", () => $b3991c2b29de475a$export$ccd6d9407403fcad);
const $b3991c2b29de475a$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("c7fDC", function(module, exports) {
$parcel$export(module.exports, "edges", () => $a406b1cadac66414$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $a406b1cadac66414$export$7fc144124ccf8292);
const $a406b1cadac66414$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $a406b1cadac66414$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("bRr7K", function(module, exports) {
$parcel$export(module.exports, "getOverElementHitbox", () => $cc1896acf38bb985$export$b9a449c20abb0e9);

var $9nEnd = parcelRequire("9nEnd");

var $gBhsg = parcelRequire("gBhsg");
function $cc1896acf38bb985$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9nEnd.axisLookup)[axis];
        const side = (0, $gBhsg.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? // begin from the start edge and grow inwards
            clientRect[mainAxis.point] : // begin from inside the end edge and grow towards the end edge
            clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $cc1896acf38bb985$export$b9a449c20abb0e9 = {
    top: $cc1896acf38bb985$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $cc1896acf38bb985$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $cc1896acf38bb985$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $cc1896acf38bb985$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("9nEnd", function(module, exports) {
$parcel$export(module.exports, "axisLookup", () => $6f2da95a654ff9d6$export$42e42cdab35a2b96);
const $6f2da95a654ff9d6$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $6f2da95a654ff9d6$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $6f2da95a654ff9d6$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $6f2da95a654ff9d6$var$vertical,
        crossAxis: $6f2da95a654ff9d6$var$horizontal
    },
    horizontal: {
        mainAxis: $6f2da95a654ff9d6$var$horizontal,
        crossAxis: $6f2da95a654ff9d6$var$vertical
    }
};

});

parcelRegister("gBhsg", function(module, exports) {
$parcel$export(module.exports, "mainAxisSideLookup", () => $83e24c6d3b7c1f23$export$a45c0cd714a4dbaa);
const $83e24c6d3b7c1f23$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("d8KWd", function(module, exports) {
$parcel$export(module.exports, "getScrollChange", () => $8f4a6d4f2c145f33$export$470a2ff46db8cee8);

var $9nEnd = parcelRequire("9nEnd");

var $8mKb2 = parcelRequire("8mKb2");

var $gBhsg = parcelRequire("gBhsg");
// We want a consistent scroll speed across devices, regardless of framerate
function $8f4a6d4f2c145f33$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $8f4a6d4f2c145f33$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $9nEnd.axisLookup)[axis];
    const side = (0, $gBhsg.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $8mKb2.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $8mKb2.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $8f4a6d4f2c145f33$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $8f4a6d4f2c145f33$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $8f4a6d4f2c145f33$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $8mKb2.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $gBhsg.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("8mKb2", function(module, exports) {
$parcel$export(module.exports, "getPercentageInRange", () => $29db21bc44d286f6$export$1a29de000a332d74);
function $29db21bc44d286f6$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("hCt4e", function(module, exports) {
$parcel$export(module.exports, "isAxisAllowed", () => $251f41aa94c07433$export$7120fdbd90bd1292);
function $251f41aa94c07433$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("7ZBkw", function(module, exports) {
$parcel$export(module.exports, "isWithin", () => $e626bf586122baf0$export$cda7a9d4399bf2e3);
function $e626bf586122baf0$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});






//# sourceMappingURL=shared.c6a4f0f4.js.map
